import type { OutpatientClinicTaskType } from '@common/contexts/support/domain/models/outpatientClinicTaskTypeModel';
import type { ModelAsDto } from '@common/contexts/support/domain/types/modelType';
import { fetchJson } from '@frontend/store/fetch';
import { OutpatientClinic } from '../constants/apiEndpoints';

type EpisodeCategory = {
    id?: string;
    name?: string;
};

export type FetchTaskTypesOptions = {
    abortSignal: AbortSignal;
    episodeCategory: EpisodeCategory | EpisodeCategory[];
};

export async function fetchTaskTypes(options: FetchTaskTypesOptions): Promise<ModelAsDto<OutpatientClinicTaskType>[]> {
    const searchParams = new URLSearchParams();

    const episodeCategories = Array.isArray(options.episodeCategory)
        ? options.episodeCategory
        : [options.episodeCategory];
    const episodeCategoryIds = episodeCategories.map((entry) => entry.id).filter(Boolean);
    const episodeCategoryNames = episodeCategories.map((entry) => entry.name).filter(Boolean);

    if (episodeCategoryIds.length > 0) {
        searchParams.append('episodeCategoryId', episodeCategoryIds.join(','));
    }

    if (episodeCategoryNames.length > 0) {
        searchParams.append('episodeCategoryName', episodeCategoryNames.join(','));
    }

    const response = await fetchJson({
        method: 'GET',
        signal: options.abortSignal,
        url: OutpatientClinic.TasksTypes + `?${searchParams.toString()}`,
    });

    if (!response?.json?.types) {
        throw new Error('Failed to fetch task types');
    }

    return response.json.types;
}
